import axios from "axios";
import { getAuthHeader } from "@/services/user.service.js";

export {
  GetWorkTimeTypes,
  LoadTargetWorkingTime,
  SaveTargetWorkingTime,
  LoadMaxWeeklyWorkingHours,
  SaveMaxWeeklyWorkingHours,
  LoadAllWorkTimes,
  SaveWorkTimes,
  AddNewWorkTimes,
  SaveWageSuppConf
};

function GetWorkTimeTypes(onSuccess, onError) {
  var headers = getAuthHeader();

  axios
    .get(
      process.env.VUE_APP_BASE_API_URL + "/enumlist/wagesupplementtimetype",
      headers
    )
    .then(response => {
      if (response.data && response.data.httpResultCode == 500) {
        onError(response);
      } else {
        onSuccess(response.data);
      }
    })
    .catch(error => {
      onError(error);
    });
}

function LoadTargetWorkingTime(
  contractNumber,
  versionNumber,
  editionId,
  configurationId,
  wageSupplementConfigurationId,
  onSuccess,
  onError
) {
  var headers = getAuthHeader();
  axios
    .get(
      process.env.VUE_APP_BASE_API_URL +
        `/contracts/${contractNumber}/versions/${versionNumber}/editions/${editionId}/configuration/${configurationId}/wagesupplementconfigurations/${wageSupplementConfigurationId}/targetworkingtime`,
      headers
    )
    .then(response => {
      onSuccess(response.data);
    })
    .catch(function(error) {
      onError(error);
    });
}

function SaveTargetWorkingTime(
  contractNumber,
  versionNumber,
  editionId,
  configurationId,
  wageSupplementConfigurationId,
  targetWorkingTimeObject,
  onSuccess,
  onError
) {
  var headers = getAuthHeader();
  axios
    .put(
      process.env.VUE_APP_BASE_API_URL +
        `/contracts/${contractNumber}/versions/${versionNumber}/editions/${editionId}/configuration/${configurationId}/wagesupplementconfigurations/${wageSupplementConfigurationId}/targetworkingtime`,
      targetWorkingTimeObject,
      headers
    )
    .then(response => {
      onSuccess(response.data);
    })
    .catch(error => {
      onError(error);
    });
}

function LoadMaxWeeklyWorkingHours(
  contractNumber,
  versionNumber,
  editionId,
  configurationId,
  wageSupplementConfigurationId,
  onSuccess,
  onError
) {
  var headers = getAuthHeader();
  axios
    .get(
      process.env.VUE_APP_BASE_API_URL +
        `/contracts/${contractNumber}/versions/${versionNumber}/editions/${editionId}/configuration/${configurationId}/wagesupplementconfigurations/${wageSupplementConfigurationId}/maxweeklyworkinghours`,
      headers
    )
    .then(response => {
      onSuccess(response.data);
    })
    .catch(function(error) {
      onError(error);
    });
}

function SaveMaxWeeklyWorkingHours(
  contractNumber,
  versionNumber,
  editionId,
  configurationId,
  wageSupplementConfigurationId,
  maxWeeklyWorkingHoursObject,
  onSuccess,
  onError
) {
  var headers = getAuthHeader();
  axios
    .put(
      process.env.VUE_APP_BASE_API_URL +
        `/contracts/${contractNumber}/versions/${versionNumber}/editions/${editionId}/configuration/${configurationId}/wagesupplementconfigurations/${wageSupplementConfigurationId}/maxweeklyworkinghours`,
      maxWeeklyWorkingHoursObject,
      headers
    )
    .then(response => {
      onSuccess(response.data);
    })
    .catch(error => {
      onError(error);
    });
}

function SaveWageSuppConf(
  contractNumber,
  versionNumber,
  editionId,
  configurationId,
  wageSupplementConfiguration,
  onSuccess,
  onError
) {
  var headers = getAuthHeader();
  axios
    .put(
      process.env.VUE_APP_BASE_API_URL +
        `/contracts/${contractNumber}/versions/${versionNumber}/editions/${editionId}/configuration/${configurationId}/wagesupplementconfigurations/${
          wageSupplementConfiguration.id
        }`,
      wageSupplementConfiguration,
      headers
    )
    .then(response => {
      onSuccess(response.data);
    })
    .catch(error => {
      onError(error);
    });
}

function LoadAllWorkTimes(
  contractNumber,
  versionNumber,
  editionId,
  configurationId,
  onSuccess,
  onError
) {
  var headers = getAuthHeader();
  axios
    .get(
      process.env.VUE_APP_BASE_API_URL +
        `/contracts/${contractNumber}/versions/${versionNumber}/editions/${editionId}/configuration/${configurationId}/arbeitszeiten`,
      headers
    )
    .then(response => {
      onSuccess(response.data);
    })
    .catch(function(error) {
      if (error.response) {
        // The request was made and the server responded with a status code
        onError(error.response.data);
      } else if (error.request) {
        // The request was made but no response was received
        onError(error.response);
      } else {
        // Something happened in setting up the request that triggered an Error;
        onError(error.message);
      }
      onError(error.config);
    });
}

function SaveWorkTimes(
  contractNumber,
  versionNumber,
  editionId,
  configurationId,
  worktimesObject,
  onSuccess,
  onError
) {
  var headers = getAuthHeader();
  axios
    .put(
      process.env.VUE_APP_BASE_API_URL +
        `/contracts/${contractNumber}/versions/${versionNumber}/editions/${editionId}/configuration/${configurationId}/arbeitszeiten`,
      worktimesObject,
      headers
    )
    .then(response => {
      onSuccess(response.data);
    })
    .catch(error => {
      onError(error);
    });
}

function AddNewWorkTimes(
  contractNumber,
  versionNumber,
  editionId,
  configurationId,
  worktimesObject,
  onSuccess,
  onError
) {
  var headers = getAuthHeader();
  axios
    .post(
      process.env.VUE_APP_BASE_API_URL +
        `/contracts/${contractNumber}/versions/${versionNumber}/editions/${editionId}/configuration/${configurationId}/arbeitszeiten`,
      worktimesObject,
      headers
    )
    .then(response => {
      onSuccess(response.data);
    })
    .catch(error => {
      onError(error);
    });
}
